<template>
    <header class="h-20 px-4 justify-between items-center flex w-full bg-transparent absolute top-0 left-0 z-10">
            <router-link to="/"><img src="../assets/logo.png" class="w-32 h-auto min-w-32" /></router-link>
            <nav class="flex space-x-6 text-lg text-gray-900 items-center max-md:hidden" id="nav">
              <router-link to="/pricing" class="transition ease-in-out text-white uppercase bg-[#0079E3]/80 py-2 px-4 gap-1 items-center justify-center flex hover:scale-105">Create my logo<svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#e8eaed"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z"/></svg></router-link>
            </nav>
            <div id="hamburger-icon" class="md:hidden" @click="toggleMobileMenu">
              <svg v-if="!hamburgerOn" class="fill-slate-900" xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px"><path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z"/></svg>
            </div>
            <div v-if="hamburgerOn" class="inset-0 fixed bg-white flex flex-col z-20 justify-center items-center md:hidden" id="mobile-menu">
              <svg @click="toggleMobileMenu" class="fill-slate-900 fixed top-6 right-4" xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
              <div class="text-3xl flex flex-col gap-8 w-full text-center">
                <router-link @click="toggleMobileMenu" to="/" class="hover:text-slate-600 hover:scale-105">Home</router-link>
                <router-link @click="toggleMobileMenu" to="/signup" class="hover:text-slate-600 hover:scale-105">Signup</router-link>
              </div>
            </div>
    </header>
</template>

<script>
export default {
    name: "Header",
  mounted() {},
  methods: {
    toggleMobileMenu() {
      this.hamburgerOn = !this.hamburgerOn;
      
    }
  },
  data() {
    return {
      hamburgerOn: false,
    }
  }
};


</script>